import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { usePromoServiceVipLimitsQuery } from '../ContactList/Promo/__generated__/PromoServiceVipLimitsQuery'

export const VipLimitsText: FC = () => {
  const { data } = usePromoServiceVipLimitsQuery()

  const vipDailyMaxContacts = data?.my?.messenger?.limits.vipDailyMaxContacts

  if (!vipDailyMaxContacts) {
    return null
  }

  return (
    <FormattedMessage
      id="vip.limits.info"
      defaultMessage="Заводите больше знакомств и общайтесь. C VIP ваш лимит вырастет до {count} {count, plural, one {контакта} few {контактов} many {контактов} other {контактов}} в день!"
      values={{ count: vipDailyMaxContacts }}
    />
  )
}
